// Proppe Frontend — Entry Point
// Imports global CSS and boots the home page.

import './styles/base.css';
import './styles/components.css';
import './styles/admin.css';

import { CONSTANTS } from './config/constants.js';
import { renderHome } from './pages/home.js';

function boot() {
  // Boot log — useful for verifying deploy in browser console
  console.log(
    `%c Proppe v${CONSTANTS.VERSION} `,
    'background:#1a4d7a;color:#fff;padding:4px 8px;border-radius:4px;font-weight:600;',
    `booted at ${new Date().toISOString()}`
  );

  const app = document.getElementById('app');
  if (!app) {
    console.error('#app element not found in index.html');
    return;
  }

  renderHome(app);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
